import React, { useState } from 'react';
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';
import Navbar from '../sections/Navbar';
import Footer from '../sections/Footer';
import ApplicationFormModal from '../components/ApplicationFormModal';
import trainingData from '../data/training.json';

const CourseDetailScreen = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const parentProgramId = location.state?.programId;

  
 let course = null;
  let parentProgram = null;

  // Search through all programs to find the course
  for (const progId in trainingData.programs) {
    const prog = trainingData.programs[progId];
    let foundCourse = null;

    // 1. Check if the program has a simple `courses` array (like Brew Passion)
    if (prog.courses) {
      foundCourse = prog.courses.find(c => c.id === courseId);
    }
    // 2. If not found, check if it has a `levels` object (like Professional Training)
    if (!foundCourse && prog.levels) {
      // Iterate through each level (Beginner, Intermediate, etc.)
      for (const levelName in prog.levels) {
        // Find the course within that level's `courses` array
        foundCourse = prog.levels[levelName].courses.find(c => c.id === courseId);
        if (foundCourse) {
          break; // Stop searching levels if we find the course
        }
      }
    }

    // If we found the course in this program, store it and the program, then stop searching.
    if (foundCourse) {
      course = foundCourse;
      parentProgram = prog;
      break; 
    }
  }

if (!course) {
    return (
      <>
        <Navbar />
        <div className="not-found-container">
          <div className="not-found-content">
            <h2>Course not found</h2>
            <Link to="/training" className="back-to-menu-link">Back to Training</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  
  const programName = parentProgram ? parentProgram.title : 'Training';

  return (
    <>
       <Navbar />
      <div className="course-detail-page">
        <button onClick={() => navigate(-1)} className="back-button">
          &larr; Back
        </button>
        <img src={course.image} alt={course.title} className="course-detail-hero-image" />
        <div className="course-detail-content">
          <h1>{course.title}</h1>
          <span className="course-duration-badge">{course.duration}</span>
          <p>{course.description}</p>
          
          {parentProgramId === 'brew-passion' && (
            <button className="apply-now-button" onClick={() => setIsModalOpen(true)}>
              Apply Now
            </button>
          )}
        </div>
      </div>
      <ApplicationFormModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        courseName={course.title}
        programName={programName}
      />
      <Footer />
    </>
  );
};

export default CourseDetailScreen;